import React from "react";
import { Navigate } from "react-router-dom";


const StkAtsPanel = React.lazy(
  () => import("../../../../../components/stk-sri/components/ats-panel/page"),
);

export const atsRoutes = [
  
  {
    path: "generate",
    element: <StkAtsPanel />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/ats/generate" />,
  },
];
